import React from 'react';

interface IProps {
  href: string;
  children: any;
}

export default function Anchor(props: IProps) {
  return (
    <a
      className="anchor"
      href={props.href}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}>
      {props.children}
    </a>
  );
}
